import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import formatName from "../../helpers/formatName";

export default function UserAvatar({ name }: { name?: string }) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        gap: theme.spacing(2, 2),
        padding: theme.spacing(4, 2),
        width: "100%",
      })}
    >
      {name ? (
        <Avatar
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          {name.trim()[0]}
        </Avatar>
      ) : (
        <Avatar />
      )}
      <Typography>
        Olá{!!name && `, ${formatName(name.trim().split(/\s+/i)[0])}`}!
      </Typography>
    </Box>
  );
}
